import Wheel from './Wheel';

export type { WheelProps, WheelCssVars } from './Wheel';
export type { WheelItem, WheelValue } from './interface';

export default Wheel;
